<template>
<div class="card overflow-auto">
	<!-- <div class=" justify-center items-center "> -->
		<div class="dash-card-header"> 
			<div class="back-link ml-3">
			<!-- <button @click="hasHistory() ? $router.go(-1) : $router.push('/dashboard')">
				<img class="pull-left" src="@/assets/back.svg" >	
			</button> -->
			</div>
			<div class="title-div font-semibold m-auto"><img src="@/assets/fitme-quarter.svg" class="color-purple"> {{$t('dashboard')}}</div>
			<div class="logout-link">
				<img class="" src="@/assets/logout.svg" @click="logout">
			</div>
		</div>
		<div class=" text-center"> 
			<span class="col-sm-12 dblock p-3 mt-4 mb-4"><b>{{$t('iafw')}}</b>
				<label class="switch ml-6">
					<input type="checkbox" @click="isActiveToggle" v-model="isActive">
					<span class="slider round"></span>
				</label>
			</span>
		</div>
	<!-- <div class="card-body"> -->
		<div class=" mt-20">
			<div class="row">
				<div class="col-sm-6 dash-item-sm">
					<router-link :to="{ name: 'registerAddress', params: {update: true} }">
						<img  src="@/assets/profile.svg" width="80" /><br/><br/>
						<span >{{$t('dashboard_profile')}}</span>
					</router-link>
				</div>
		
				<div class="dash-item-sm col-sm-6  ">
					<router-link :to="{ name: 'registerContract', params: {update: true} }">
						<!-- <div > -->
						<img  src="@/assets/document-approve.svg" width="55" /><br/><br/>
						{{$t('dashboard_contract')}}
						<!-- </div> -->
					</router-link>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-12 dash-item-lg">
					<router-link :to="{ name: 'registerJobtypes', params: {update: true} }">
						<!-- <div> -->
						<img  src="@/assets/industries.svg" width="60" /><br/><br/>
						<span >{{$t('dashboard_function')}}</span>
						<!-- </div> -->
					</router-link>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6 dash-item-sm">
					<router-link :to="{ name: 'registerTransportation', params: {update: true} }">
						<!-- <div> -->
						<img  src="@/assets/transport.svg" width="60" /><br/><br/>
						{{$t('dashboard_transport')}}
						<!-- </div> -->
					</router-link>
				</div>
				<div class="col-sm-6 dash-item-sm ">
					<router-link :to="{ name: 'registerShifts', params: {update: true} }">
						<img src="@/assets/shifts.svg" width="60" /><br/><br/>
						{{$t('dashboard_availablity')}}
					</router-link>
				</div>
				<!-- <div v-if="!user.assessmentTaken" class="col-sm-6 dash-item-sm ">
					<router-link :to="{ name: 'assessment' }">
						<img src="@/assets/assessment.svg" width="60" /><br/><br/>
						{{$t('dashboard_assessment')}}
					</router-link>
				</div> -->
			</div>
		</div>
</div>
</template>

<script>
export default {
	name: "Login",
	data() {
		return {
			user: [],
			ukey: '',
			isActive: false
		}
    },
	async created() {
		this.user = JSON.parse(localStorage.getItem('user'))
		if (this.user) {
			this.ukey = this.user.ukey

			if (this.user.isActive) {
				this.isActive = true
			}
		}
		await this.$store.dispatch('checkAuth');

		setTimeout(async () => {
			await this.$store.dispatch('clearAuth');
			await this.$router.push({ name: 'home' });
		}, 6 * 1000000) // 100 minutes to auto logout
	},
    methods:{
        async logout(){ 
            this.error = null;
			try {
				await this.$store.dispatch('logout');
			} catch (error) {
				this.error = error;
			} finally {
				this.loading = false;
				await this.$router.push({ name: 'home' });
			}
         },
		 async isActiveToggle() {
			this.error = null;
			let data 
			setTimeout(async () => {
				data = {
					isActive: this.isActive,
					ukey: this.ukey
				}
				try {
					await this.$store.dispatch('isActiveToggle', data);
				} catch (error) {
					this.error = error;
				} finally {
					this.loading = false;
					await this.$store.dispatch('checkAuth');
				}
			}, 500);
		 }
    }
}

</script>
<style scoped>
.m-auto {
	margin: auto;
}
</style>